import { Inject } from '@odinjs/odin';

import { FetchAPI, FieldAPI, PanelAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnMount, OnSelect } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, SelectEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { isEmptyArrayOrObject, isEmptyObject } from '@philips-emr/tws-utils';

import { ChamadoDetalhesAliases as Aliases, FragmentNames } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

import { Call } from './chamados-controller';

interface Attachment {
  dsFile: string;
  nrSeqAttachment: number;
}

@Controller({ fragment: FragmentNames.CHAMADO_DETALHES })
class ChamadoDetalhesController extends BaseController {

  @Inject('panel-history')
  private panelHistory: PanelAPI;
  @Inject('field-cancel-date')
  private fieldCancelDate: FieldAPI;
  @Inject('field-cancel-reason')
  private fieldCancelReason: FieldAPI;
  @Inject('field-attachments')
  private fieldAttachments: FieldAPI;

  @OnMount([Aliases.FETCH_CALL, Aliases.FETCH_HISTORY, Aliases.FETCH_ATTACHMENTS])
  onMountFetch(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqBeneficiario, nrSeqCall } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
    api.setParameters({ nrSeqCall, nrSeqBeneficiario });
    api.forceFetch();
  }

  @OnAfterFetch(Aliases.FETCH_HISTORY)
  onAfterFetchHistory(event: FetchEvent): void {
    const data = event.data;
    if (!data) {
      this.panelHistory.setVisible(false);
    }
  }

  @OnAfterFetch(Aliases.FETCH_CALL)
  onAfterFetchCall(event: FetchEvent): void {
    const data = event.data as Call;
    const { dtClose } = data;
    if (isEmptyObject(dtClose)) {
      this.fieldCancelDate.setVisible(false);
      this.fieldCancelReason.setVisible(false);
    }
  }

  @OnAfterFetch(Aliases.FETCH_ATTACHMENTS)
  onAfterFetchAttachments(event: FetchEvent): void {
    const data = event.data as Attachment;
    if (isEmptyArrayOrObject(data)) {
      this.fieldAttachments.setVisible(false);
    }
  }

  @OnSelect(Aliases.HPMS_ATTACHMENTS_LIST)
  onSelectAttachment(event: SelectEvent<Attachment>): void {
    const { value } = event;
    const { nrSeqAttachment, dsFile } = value;
    const nmTable = 'calls';
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();

    FileService.download(Endpoints.GET.DOWNLOAD_CHAMADO_ANEXO, dsFile,
      { nmTable, nrSeqAttachment, nrSeqBeneficiario }, HttpMethod.GET)
      .catch(() => ToastService.open({ level: ToastLevel.ERROR, message: 'beneficiary.arquivo-nao-localizado' }));

  }

}

export default ChamadoDetalhesController;
